import React, { useState, useEffect } from 'react';
import api from '../services/api';

const Configuracoes = () => {
  const [tipoConfig, setTipoConfig] = useState('recorrente');
  const [janela, setJanela] = useState({ 
    dia_semana: 1, 
    data_especifica: '', 
    hora_inicio: '08:00', 
    hora_fim: '18:00',
    hora_almoco_ini: '12:00',
    local: 'Tatuapé' // Local padrão
  });
  const [listaConfiguracoes, setListaConfiguracoes] = useState([]);

  const carregarConfiguracoes = async () => {
    try {
      const res = await api.get('/admin/configuracoes-janelas');
      setListaConfiguracoes(res.data);
    } catch (error) {
      console.error("Erro ao carregar configurações", error);
    }
  };

  useEffect(() => {
    carregarConfiguracoes();
  }, []);

  const salvar = async () => {
    try {
      const payload = { ...janela };
      if (tipoConfig === 'recorrente') {
        payload.data_especifica = null;
      } else {
        payload.dia_semana = null;
        if (!payload.data_especifica) return alert("Por favor, selecione uma data.");
      }
      if (!payload.hora_almoco_ini) payload.hora_almoco_ini = null;

      await api.post('/admin/configurar-janela', payload);
      alert('Disponibilidade adicionada com sucesso!');
      carregarConfiguracoes();
    } catch (err) {
      alert("Erro ao salvar configuração.");
    }
  };

  const deletar = async (id) => {
    if(window.confirm("Deseja realmente remover este horário?")) {
      await api.delete(`/admin/configuracoes-janelas/${id}`);
      carregarConfiguracoes();
    }
  };

  const diasSemanaMap = { 0: 'Domingo', 1: 'Segunda', 2: 'Terça', 3: 'Quarta', 4: 'Quinta', 5: 'Sexta', 6: 'Sábado' };

  return (
    <div style={styles.container}>
      <div style={styles.mainWrapper}>
        <div style={styles.card}>
          <div style={styles.header}>
            <h2 style={styles.title}>Abertura de Agenda</h2>
            <p style={styles.subtitle}>Configure os períodos e locais disponíveis para a IA realizar marcações</p>
          </div>

          <div style={styles.toggleGroup}>
            <button style={tipoConfig === 'recorrente' ? styles.toggleActive : styles.toggleInactive} onClick={() => setTipoConfig('recorrente')}>
              Toda Semana (Fixo)
            </button>
            <button style={tipoConfig === 'especifica' ? styles.toggleActive : styles.toggleInactive} onClick={() => setTipoConfig('especifica')}>
              Data Específica
            </button>
          </div>

          <div style={styles.form}>
            {tipoConfig === 'recorrente' ? (
              <div style={styles.inputGroup}>
                <label style={styles.label}>Dia da Semana</label>
                <select style={styles.select} value={janela.dia_semana} onChange={e => setJanela({...janela, dia_semana: parseInt(e.target.value)})}>
                  <option value="1">Toda Segunda-feira</option>
                  <option value="2">Toda Terça-feira</option>
                  <option value="3">Toda Quarta-feira</option>
                  <option value="4">Toda Quinta-feira</option>
                  <option value="5">Toda Sexta-feira</option>
                  <option value="6">Todo Sábado</option>
                </select>
              </div>
            ) : (
              <div style={styles.inputGroup}>
                <label style={styles.label}>Selecione a Data</label>
                <input type="date" style={styles.input} value={janela.data_especifica} onChange={e => setJanela({...janela, data_especifica: e.target.value})} />
              </div>
            )}

            {/* SELEÇÃO DO LOCAL DE ATENDIMENTO */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Local de Atendimento</label>
              <select style={styles.select} value={janela.local} onChange={e => setJanela({...janela, local: e.target.value})}>
                <option value="Tatuapé">Edifício Ferrara - Tatuapé</option>
                <option value="Itaim Bibi">Itaim Bibi</option>
              </select>
            </div>

            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Início do Turno</label>
                <input type="time" style={styles.input} value={janela.hora_inicio} onChange={e => setJanela({...janela, hora_inicio: e.target.value})} />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Fim do Turno</label>
                <input type="time" style={styles.input} value={janela.hora_fim} onChange={e => setJanela({...janela, hora_fim: e.target.value})} />
              </div>
            </div>

            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Início do Almoço (Pausa de 1h - Opcional)</label>
                <input type="time" style={styles.input} value={janela.hora_almoco_ini || ''} onChange={e => setJanela({...janela, hora_almoco_ini: e.target.value})} />
              </div>
            </div>

            <button onClick={salvar} style={styles.button}>Adicionar Horário</button>
          </div>
        </div>

        <div style={styles.listCard}>
          <h3 style={styles.listTitle}>Horários Ativos na Clínica</h3>
          <div style={styles.listContainer}>
            {listaConfiguracoes.length === 0 ? (
              <p style={styles.emptyText}>Nenhum horário configurado ainda.</p>
            ) : (
              listaConfiguracoes.map(item => (
                <div key={item.id} style={styles.listItem}>
                  <div>
                    <span style={styles.itemTag}>
                      {item.data_especifica ? `Data Única: ${item.data_especifica.split('-').reverse().join('/')}` : `Recorrente: ${diasSemanaMap[item.dia_semana]}`}
                      <span style={{color: '#0F766E', marginLeft: '8px'}}>📍 {item.local}</span>
                    </span>
                    <div style={styles.itemTime}>
                      {item.hora_inicio} às {item.hora_fim}
                      {item.hora_almoco_ini && <span style={{fontSize: '12px', color: '#B59978', marginLeft: '8px', fontWeight: '600'}}>(Almoço: {item.hora_almoco_ini})</span>}
                    </div>
                  </div>
                  <button onClick={() => deletar(item.id)} style={styles.deleteBtn}>Remover</button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '40px 20px', display: 'flex', justifyContent: 'center', backgroundColor: '#FAF8F5', minHeight: '100vh', fontFamily: '"Montserrat", sans-serif' },
  mainWrapper: { display: 'flex', flexDirection: 'column', gap: '32px', width: '100%', maxWidth: '600px' },
  card: { backgroundColor: '#FFFFFF', borderRadius: '12px', padding: '40px', border: '1px solid #EBE6E0' },
  header: { marginBottom: '24px', textAlign: 'center' },
  title: { fontSize: '24px', color: '#2C2A29', margin: 0, fontFamily: '"Playfair Display", serif', fontWeight: '500' },
  subtitle: { fontSize: '12px', color: '#7A7571', marginTop: '6px', textTransform: 'uppercase', letterSpacing: '1px' },
  toggleGroup: { display: 'flex', backgroundColor: '#FCFBF9', borderRadius: '8px', padding: '6px', marginBottom: '24px', border: '1px solid #EBE6E0' },
  toggleActive: { flex: 1, padding: '12px', backgroundColor: '#FFFFFF', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', color: '#B59978', boxShadow: '0 2px 4px rgba(0,0,0,0.02)', cursor: 'pointer', transition: 'all 0.2s' },
  toggleInactive: { flex: 1, padding: '12px', backgroundColor: 'transparent', border: 'none', fontSize: '13px', fontWeight: '500', color: '#A09B96', cursor: 'pointer', transition: 'all 0.2s' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  label: { fontSize: '11px', fontWeight: '500', color: '#7A7571', marginBottom: '8px', display: 'block', textTransform: 'uppercase', letterSpacing: '0.5px' },
  select: { width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #EBE6E0', backgroundColor: '#FCFBF9', outline: 'none' },
  input: { width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #EBE6E0', backgroundColor: '#FCFBF9', outline: 'none' },
  row: { display: 'flex', gap: '16px' },
  inputGroup: { flex: 1 },
  button: { padding: '16px', backgroundColor: '#2C2A29', color: '#FFFFFF', border: 'none', borderRadius: '8px', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px', cursor: 'pointer', marginTop: '8px' },
  listCard: { backgroundColor: '#FFFFFF', borderRadius: '12px', padding: '32px', border: '1px solid #EBE6E0' },
  listTitle: { fontSize: '18px', color: '#2C2A29', margin: '0 0 20px 0', fontFamily: '"Playfair Display", serif', fontWeight: '500' },
  listContainer: { display: 'flex', flexDirection: 'column', gap: '12px' },
  emptyText: { fontSize: '14px', color: '#A09B96', fontStyle: 'italic', textAlign: 'center', padding: '20px 0' },
  listItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', backgroundColor: '#FCFBF9', border: '1px solid #EBE6E0', borderRadius: '8px' },
  itemTag: { fontSize: '10px', fontWeight: '600', color: '#B59978', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '4px' },
  itemTime: { fontSize: '15px', color: '#2C2A29', fontWeight: '500' },
  deleteBtn: { backgroundColor: '#FDF5F5', color: '#A67C7C', border: 'none', padding: '8px 16px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '500', transition: 'background-color 0.2s' }
};

export default Configuracoes;